'use strict';
var $export   = require('./$.export')
  , $includes = require('./$.array-includes')(true);

$export($export.P, 'Array', {
  // https://github.com/domenic/Array.prototype.includes
  includes: function includes(el /*, fromIndex = 0 */){
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

require('./$.add-to-unscopables')('includes');


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/~/core-js/modules/es7.array.includes.js
 ** module id = 560
 ** module chunks = 0
 **/